import AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
  endpoint: `https://s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com`
});

const s3 = new AWS.S3();

export const uploadImageToS3 = async (file) => {
  if (!file) {
    throw new Error("No file provided for upload.");
  }

  const extension = file.type?.split("/")[1] || "jpg"; // Default to jpg if no type
  const fileName = `${new Date().getTime()}.${extension}`; // Corrected file path

  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET,
    Key: `TTpro/blogs/` + fileName, // Corrected Key format
    Body: file,
    ContentType: file.type,
    // ACL: "public-read", // Make the file publicly accessible (optional)
  };

  try {
    const { Location } = await s3.upload(params).promise();
    return fileName; // Return the uploaded file URL
  } catch (err) {
    console.error("Upload Error:", err);
    throw err;
  }
};


export const uploadImageNewsToS3 = async (file) => {
  if (!file) {
    throw new Error("No file provided for upload.");
  }

  const extension = file.type?.split("/")[1] || "jpg"; // Default to jpg if no type
  const fileName = `${new Date().getTime()}.${extension}`; // Corrected file path

  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET,
    Key: `TTpro/news/` + fileName, // Corrected Key format
    Body: file,
    ContentType: file.type,
    // ACL: "public-read", // Make the file publicly accessible (optional)
  };

  try {
    const { Location } = await s3.upload(params).promise();
    return fileName; // Return the uploaded file URL
  } catch (err) {
    console.error("Upload Error:", err);
    throw err;
  }
};
export const deleteMediaOnS3 = async (keyPath, arrImageName) => {
  // Configure AWS
  AWS.config.update({
    region: 'us-east-1',
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'us-east-1:9db8ad1c-1e89-4218-8f32-70d7fb8765b1',
    }),
  });

  const s3 = new AWS.S3();

  // Helper function to delete an object from S3
  const deleteObjectFromS3 = (bucketName, objectKey) => {
    const params = {
      Bucket: bucketName,
      Key: objectKey,
    };
    return s3.deleteObject(params).promise();
  };

  try {
    const deletePromises = arrImageName.map((imageName) => {
      const objectKey = `${keyPath}/${imageName}`;

      // return s3.deleteObject(objectKey).promise();

      return deleteObjectFromS3(process.env.REACT_APP_AWS_BUCKET, objectKey);
    });

    // Wait for all deletions to finish
    await Promise.all(deletePromises);

  } catch (error) {
    console.error('Error occurred while deleting objects:', error);
  }
};

// folder : /Hrms/profile_photo/